import useMerchantData from "./hooks/useMerchantData";
import useMerchantFilters from "./hooks/useMerchantFilters";
import ManageMerchantContent from "./ManageMerchantContent";

const ManageMerchant = () => {
  const {
    pagination,
    apiFilters,
    setPagination,
    searchQuery,
    segment,
    setSearchQuery,
    setSegment,
  } = useMerchantFilters();

  const {
    merchants,
    totalPages,
    totalElements,
    isLoading,
    isFetching,
    isError,
    refetch,
  } = useMerchantData(apiFilters);

  return (
    <ManageMerchantContent
      merchants={merchants}
      totalPages={totalPages}
      totalElements={totalElements}
      loadingData={isLoading}
      isFetching={isFetching}
      isError={isError}
      onRetry={refetch}
      pagination={pagination}
      setPagination={setPagination}
      searchQuery={searchQuery}
      segment={segment}
      setSearchQuery={setSearchQuery}
      setSegment={setSegment}
    />
  );
};

export default ManageMerchant;
